import paymanSetting from './payman-setting'
import paymanInfo from './payman-info'

export {
    paymanInfo,
    paymanSetting,
}